import { render, staticRenderFns } from "./SocialMediaConsent.vue?vue&type=template&id=64e9c840&"
import script from "./SocialMediaConsent.vue?vue&type=script&lang=js&"
export * from "./SocialMediaConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports